import { injector } from '@asd-stan/injector/injector';
import { ModalService } from '@asd-stan/shell/domain/modal.service';
import { ToasterService } from '@asd-stan/shell/domain/toaster.service';
import { MODAL_SERVICE, TOASTER_SERVICE } from '@asd-stan/shell/infrastructure/constants';

injector.set(MODAL_SERVICE, new ModalService());
injector.set(TOASTER_SERVICE, new ToasterService());
